import googleButtonTemplate from './google-button.html';
import './google-style.scss';

// .component('googleSignIn',
export const googleSignInComponent = {
  template: googleButtonTemplate,
  controller: Controller
};

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($scope, $injector) {
  var $ctrl = this;
  var $globals = {};
  var $svcs = { $ctrl, $globals, $injector, $scope };

  $injector.invoke(initGlobals, null, $svcs);
  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the Controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $svcs) {
  $ctrl.googleLogin = $injector.invoke(googleLogin, null, $svcs);
}

/*******************************************************************************
 * initGlobals */
/**
 * Initializes the Globals object.
 *******************************************************************************/
/* @ngInject */ function initGlobals($globals, LoginConstants) {
  const oauth = LoginConstants.oauthConfig;

  Object.assign($globals, {
    oauth,

    /*------------------------------------*/
    /* These options are used as query    */
    /* string parameters for Google OAuth */
    /*------------------------------------*/
    oauthOptions: {
      redirect_uri: oauth.redirectURI,
      client_id: oauth.google.clientID,
      access_type: 'offline',
      response_type: 'code',
      prompt: 'select_account',
      scope: oauth.google.consent.join(' '),
      state: oauth.google.name
    }
  });
}

/*******************************************************************************
 * Controller: googleLogin */
/**
 * Click handler for the SSO button. Redirects to the Google OAuth page by
 * setting the window location to the Google OAuth URL with the query string.
 *******************************************************************************/
/* @ngInject */ function googleLogin($globals) {
  const queryString = new URLSearchParams($globals.oauthOptions);

  return function () {
    window.location.href = `${$globals.oauth.google.rootURL}?${queryString.toString()}`;
  };
}
